import { render, staticRenderFns } from "./LateReasons.vue?vue&type=template&id=67fcb5da"
import script from "./LateReasons.vue?vue&type=script&lang=js"
export * from "./LateReasons.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/late-reasons/late-reasons.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports